// import { BLOGPOST_LOAD } from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // case BLOGPOST_LOAD:
      // return state;
    default:
      return state;
  }
};

export default reducer;
